<script setup lang="ts">
// Lucide-style `life-buoy` — the Help & Support hero mark (Figma 35143:147556).
// PrimeIcons has no lifebuoy, and `question-circle` is already the FAQ card's
// icon directly below it, so reusing it would make the two read as one thing.
defineOptions({ inheritAttrs: false })
</script>

<template>
  <svg
    viewBox="0 0 32 32"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    xmlns="http://www.w3.org/2000/svg"
    v-bind="$attrs"
  >
    <circle cx="16" cy="16" r="13.333" />
    <circle cx="16" cy="16" r="5.333" />
    <path d="M6.573 6.573 12.227 12.227" />
    <path d="M19.773 12.227 25.427 6.573" />
    <path d="M19.773 19.773 25.427 25.427" />
    <path d="M12.227 19.773 6.573 25.427" />
  </svg>
</template>
